import {Component, OnInit} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { UserService } from 'src/app/_core/lib/user.service';

@Component({
    selector: 'app-footer',
    templateUrl: './app.footer.component.html',
    styles: [`
        .footer-icon {
            width: 35px;
            height: 35px;
            object-fit: contain;
        }
    `]
})
export class AppFooterComponent implements OnInit {

    activeRoute: string = 'dashboard';

    constructor(
        private router: Router,
        public userService: UserService  // Cambiato in public per usarlo nel template
    ) {
        // Traccia la route attiva
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            this.activeRoute = event.url.split('/')[1] || 'dashboard';
        });
    }

    ngOnInit() {
    }

    // Getter dinamici che si aggiornano automaticamente
    get buttons(): FBFooterButton[] {
        const isSeller = this.userService.roleChecker.is.seller();
        const myAuctionsRoute = isSeller ? 'my-sales' : 'my-wins';
        const myAuctionsLabel = isSeller ? 'Mie Vendite' : 'Mie Aste';

        return [
            FBFooterButton.create('assets/images/footer/home.png', 'Home', 'dashboard').setAction(() => {
                this.router.navigate(['dashboard']);
            }),
            FBFooterButton.create('assets/images/footer/asta.png', 'Aste', 'auction').setAction(() => {
                this.router.navigate(['auction']);
            }),
            FBFooterButton.create('assets/images/footer/mycart.png', myAuctionsLabel, myAuctionsRoute).setAction(() => {
                this.router.navigate([myAuctionsRoute]);
            }),
            FBFooterButton.create('assets/images/footer/profile.png', 'Profilo', 'profile').setAction(() => {
                this.router.navigate(['profile']);
            })
        ];
    }

    isActive(route: string): boolean {
        // Gestisce anche il caso in cui sia my-wins che my-sales devono essere considerati attivi
        // quando l'utente è sulla route corrispondente
        if (route === 'my-sales' || route === 'my-wins') {
            return this.activeRoute === 'my-sales' || this.activeRoute === 'my-wins';
        }
        return this.activeRoute === route;
    }
}

class FBFooterButton {

    action: () => void = () => {};

    private constructor(
        public icon: string,
        public label: string,
        public route: string
    ) {}

    public static create = (icon: string, label: string, route: string) =>
        new FBFooterButton(icon, label, route);

    setAction(value: () => void) {
        this.action = value;
        return this;
    }
}
